<template>
  <section>
    <p>
       Найдено сущностей: {{ pagination.total }}
    </p>
    <div class="scroller" ref="scroller" @scroll.passive="handleTableScroll">
      <div class="scroller__inner" :style="{width: scroller.width + 'px'}"></div>
    </div>
    <a-table
      class="table"
      ref="table"
      :loading="isLoading"
      :scroll="{ x: true }"
      :columns="columns"
      :dataSource="data"
      :pagination="pagination"
      :customRow="customRow"
      :rowSelection="selection"
      @change="handleTableChange"
    >
    </a-table>
    <a-modal v-model="modal.isVisible" :title="modal.title">
      <div v-html="modal.text"></div>
      <template slot="footer">
        <a-button @click="modal.isVisible = false">
          Закрыть
        </a-button>
      </template>
    </a-modal>
  </section>
</template>

<script>
export default {
  name: 'Entity',
  props: ['forSearch', 'name', 'visible', 'selection'],
  data() {
    return {
      isLoading: true,
      modal: {
        isVisible: false,
        title: '',
        text: '',
      },
      data: [],
      sorting: {
        key: '',
        dir: '',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100', '250', '500', '1000'],
      },
      filter: {},
      scroller: {
        interval: null,
        width: 0,
        left: 0,
      },
    };
  },
  computed: {
    currentEntity() {
      return this.forSearch ? this.name : this.$store.getters.currentEntity;
    },
    entities() {
      return this.$store.getters.entities;
    },
    entityTrigger() {
      return this.$store.getters.entityTrigger;
    },
    params() {
      const obj = this.$store.getters.columnsSettings.find(v => v.entity === this.currentEntity);
      const hiddenColumns = obj ? obj.hidden : [];
      return Object.fromEntries(
        Object.entries(this.entities[this.currentEntity].params)
          .filter(entry => !hiddenColumns.includes(entry[1].name)),
      );
    },
    paramsKeys() {
      return Object.keys(this.params);
    },
    columns() {
      const obj = this.$store.getters.columnsSettings.find(v => v.entity === this.currentEntity);
      const sorted = obj ? obj.sorted : [];

      return Object.values(this.params).map((v) => {
        const modifier = (name, text, gui, row) => {
          if (!this.modifiers[name]) {
            return text;
          }

          try {
            return this.modifiers[name](text, name, gui, row);
          } catch {
            return text;
          }
        };

        return {
          title: v.gui_name || v.name,
          key: v.name,
          dataIndex: v.name,
          sorter: !!v.is_orderable,
          sortOrder: this.sorting.key === v.name && (this.sorting.dir === 'DESC' ? 'descend' : 'ascend'),
          filters: [],
          customRender: (text, row) => this.$createElement('span', { domProps: { innerHTML: modifier(v.name, text, v.gui_name || v.name, row) } }),
        };
      }).sort((a, b) => sorted.indexOf(a.key) - sorted.indexOf(b.key));
    },
    modifiers() {
      const result = {};
      this.paramsKeys.forEach((param) => {
        if (this.params[param].modifier_function) {
          try {
            // eslint-disable-next-line
            result[param] = eval(this.params[param].modifier_function);
          } catch {
            // eslint-disable-no-empty
          }
        }
      });
      return result;
    },
  },
  methods: {
    exportData() {
      const params = new URLSearchParams({
        action: 'search',
        entity: this.currentEntity,
        order_by: this.sorting.key,
        direction: this.sorting.dir,
        filter: JSON.stringify(this.filter),
        export_as: 'xlsx',
        access_token: this.$store.getters.token,
      });
      this.columns.forEach((col) => {
        params.append('params[]', col.dataIndex);
      });
      window.open(`https://api.vsenauka.ru/API/v1.0/?${params.toString()}`, '_blank');
    },
    getData() {
      if (!this.forSearch) {
        this.$store.commit('setCurrentEntity', this.currentEntity);
      }
      this.isLoading = true;
      this.$api.search({
        entity: this.currentEntity,
        sortKey: this.sorting.key,
        sortDir: this.sorting.dir,
        start: (this.pagination.current - 1) * this.pagination.pageSize,
        length: this.pagination.pageSize,
        params: this.paramsKeys.includes('id') ? this.paramsKeys : [...this.paramsKeys, 'id'],
        filter: JSON.stringify(this.filter),
      }, this.forSearch ? 'entity-modal' : 'entity').then((response) => {
        if (response.data) {
          this.data = Object.values(response.data).map(v => ({
            ...v,
            key: v.id,
          }));
        } else {
          this.data = [];
        }
        this.pagination.total = response.total;
        this.isLoading = false;
        this.$nextTick(this.addListeners);
      }).catch((e) => {
        if (e !== 'canceled') {
          this.isLoading = false;
        }
      });
    },
    resetSorting() {
      this.sorting = {
        key: '',
        dir: '',
      };
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (!sorter.order) {
        this.resetSorting();
      } else {
        this.sorting.dir = sorter.order === 'descend' ? 'DESC' : 'ASC';
        this.sorting.key = sorter.columnKey;
      }
      this.getData();
    },
    handleFilter(filter) {
      this.filter = filter;
      this.pagination.current = 1;
      this.getData();
    },
    customRow(record) {
      const that = this;
      return {
        on: {
          click() {
            if (that.forSearch) {
              that.$emit('rowClick', record.id);
            }
          },
          dblclick() {
            if (!that.forSearch && that.rights.edit) {
              that.$store.commit('setIsRowModalVisible', true);
              that.$store.commit('setRowModalId', record.id);
            }
          },
        },
      };
    },
    addListeners() {
      const els = document.querySelectorAll('._show-ellipsis-value');
      Array.from(els).forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          this.modal.title = e.target.dataset.gui;
          this.modal.text = decodeURIComponent(e.target.dataset.val).replace(/%27/g, '\'') || '';
          this.modal.isVisible = true;
        });
      });
    },
    handleScroller() {
      this.scroller.width = this.$refs.table.$el.querySelector('.ant-table-tbody').clientWidth;
    },
    handleTableScroll(e) {
      const scroll = e.target.scrollLeft;
      if (this.scroller.scroll !== scroll) {
        this.scroller.scroll = scroll;
        this.$refs.table.$el.querySelector('.ant-table-body').scrollLeft = scroll;
        this.$refs.scroller.scrollLeft = scroll;
      }
    },
  },
  watch: {
    visible() {
      this.data = [];
      this.filter = {};
      this.resetSorting();
      if (this.visible) {
        this.getData();
      }
    },
    entities: {
      handler() {
        if (!this.forSearch) {
          this.getData();
        }
      },
      deep: true,
    },
    entityTrigger() {
      if (!this.forSearch) {
        this.getData();
      }
    },
    currentEntity() {
      this.data = [];
      this.filter = {};
      this.resetSorting();
      if (!this.forSearch) {
        this.getData();
      }
    },
    paramsKeys() {
      if (!this.paramsKeys.includes(this.sorting.key)) {
        this.resetSorting();
      }
      if (!this.forSearch) {
        this.getData();
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.scroller.interval = setInterval(this.handleScroller, 300);
    this.$refs.table.$el.querySelector('.ant-table-body').addEventListener('scroll', this.handleTableScroll);
  },
  destroyed() {
    clearInterval(this.scroller.interval);
    this.$refs.table.$el.querySelector('.ant-table-body').removeEventListener('scroll', this.handleTableScroll);
  },
};
</script>

<style lang="scss" scoped>
.scroller {
  margin-top: 15px;
  overflow: auto;
  position: sticky;
  top: -1px;
  z-index: 100;

  &__inner {
    height: 1px;
  }
}
</style>
